import axios from 'axios';
import { LanguageObject } from '@/i18n';

type Privilege = 'readonly' | 'admin' | 'accompany' | 'sub_org';
type PrivilegeType = 'oversight' | 'serviceprovider' | 'admin' | 'superadmin';

interface Role {
  id?: number;
  name: LanguageObject;
  type?: PrivilegeType;
  note?: string;
  permissions: {
    sp_privs?: Privilege[];
    oversight_privs?: Privilege[];
    oversight_children_privs?: Privilege[];
  };
}

const api = {
  list: async () => {
    const resp = await axios.get<Role[]>('/role/list.php');
    return resp.data;
  },

  get: async (id: number) => {
    const resp = await axios.get<Role>('/role/get.php', {
      params: { id: id },
    });
    return resp.data;
  },

  add: async (user: Role) => {
    const resp = await axios.post<{ id: number }>('/role/add.php', user);
    return resp.data.id;
  },

  update: async (user: Partial<Role>) => {
    await axios.post('/role/update.php', user);
  },

  remove: async (id: number) => {
    await axios.delete('/role/delete.php', {
      params: { id: id },
    });
  },
};

const getPrivileges = async () => {
  const resp = await axios.get<Privilege[]>('/authentication/privileges.php');
  return resp.data;
};

const getPrivilegeTypes = async () => {
  const resp = await axios.get<PrivilegeType[]>(
    '/authentication/privilegeTypes.php'
  );
  return resp.data;
};

export default {
  api,
  getPrivileges,
  getPrivilegeTypes,
};

export { Role, Privilege, PrivilegeType };
